import rung from "rung/src/rung";
import Queue from "peculiar/queue";

const rng = rung();

function removeRandom(array) {
  const index = rng.integer(array.length);
  const removedItem = array.splice(index, 1);
  return removedItem[0];
}

function getAdjacentCells(width, height, x, y) {
  var cells = [];

  // North
  if (y > 0) cells.push({x, y: y-1});

  // North-East
  //if (y > 0 && x < width) cells.push({x: x+1, y: y-1});

  // East
  if (x < width-1) cells.push({x: x+1, y});

  // South-East
  //if (y < height && x < width) cells.push({x: x+1, y: y+1});

  // South
  if (y < height-1) cells.push({x, y: y+1});

  // South-West
  //if (y < height && x > 0) cells.push({x: x-1, y: y+1});

  // West
  if (x > 0) cells.push({x: x-1, y});

  // North-West
  //if (y > 0 && x > 0) cells.push({x: x-1, y: y-1});

  return cells;
}

function fillConnectedAreas(terrain, cell) {
  const visited = new Set();
  const areas = [];

  for (let y = 0; y < terrain.length; y++) {
    for (let x = 0; x < terrain[0].length; x++) {
      if (terrain[y][x] != cell || visited.has(`${x},${y}`)) continue;

      const area = [];
      const frontier = new Queue();
      frontier.push({x, y});

      while (!frontier.isEmpty()) {
        const currentCell = frontier.poll();
        area.push(currentCell);

        for (const nextCell of getAdjacentCells(terrain[0].length, terrain.length, currentCell.x, currentCell.y)) {
          const label = `${nextCell.x},${nextCell.y}`;
          if (visited.has(label)) continue;
          visited.add(label);

          if (terrain[nextCell.y][nextCell.x] == cell) {
            frontier.push(nextCell);
            area.push(nextCell);
          }
        }
      }

      areas.push(area);
    }
  }

  return areas;
}

// TODO: modifies the grid in place rather than returns it, should be fixed
function jaggedFloodFill(grid, origin, max, cell) {
  const visited = new Set();
  const area = [];
  const frontier = [];

  visited.add(origin);
  area.push(origin);
  frontier.push(origin);

  while (frontier.length != 0) {
    if (area.length >= max) return;

    const currentCell = removeRandom(frontier);

    for (let nextCell of getAdjacentCells(grid[0].length, grid.length, currentCell.x, currentCell.y)) {
      if (visited.has(nextCell)) continue;

      visited.add(nextCell);

      if (grid[nextCell.y][nextCell.x] != cell) {
        frontier.push(nextCell);
        area.push(nextCell);
        grid[nextCell.y][nextCell.x] = cell;
      }
    }
  }

  return;
}

export {
  fillConnectedAreas,
  getAdjacentCells,
  jaggedFloodFill
}
